/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* start-ralph-upsell */
function upsellFetch(e){
  fetch('/cart/add.js',{
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({id:e.dataset.productId,quantity:e.dataset.productQuantity})
      }).then(() => {
                  console.log("success!");
                  document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
  				  console.log(e);
  				  // document.querySelector("button[name='checkout']").click();
}).catch(er => {
      console.log("fail!");
      console.log(er)
    });
}
/* end-ralph-upsell */

/* start-axe-slider */
var divisor = document.getElementById("divisor"),
    handle = document.getElementById("handle"),
    slider = document.getElementById("slider");

function moveDivisor() {
  if(!handle){
    return;
  }
  handle.style.left = slider.value+"%";
  divisor.style.width = slider.value+"%";
}

window.onload = function() {
	moveDivisor();
};
/* end-axe-slider */

/* start-axe-open-drawer */
function openDrawer(e) {
  setTimeout(() => document.querySelector("a[data-drawer-id='sidebar-cart']").click(), 500);
}
/* end-axe-open-drawer */